var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDraggableDotsHorizontal = function SvgDraggableDotsHorizontal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 210,
    height: 120,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillOpacity: 0.45,
    clipPath: "url(#draggable-dots-horizontal_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 80v30c0 5.523 4.477 10 10 10h30c5.523 0 10-4.477 10-10V80c0-5.523-4.477-10-10-10H10C4.477 70 0 74.477 0 80M0 10v30c0 5.523 4.477 10 10 10h30c5.523 0 10-4.477 10-10V10c0-5.523-4.477-10-10-10H10C4.477 0 0 4.477 0 10M80 80v30c0 5.523 4.477 10 10 10h30c5.523 0 10-4.477 10-10V80c0-5.523-4.477-10-10-10H90c-5.523 0-10 4.477-10 10M80 10v30c0 5.523 4.477 10 10 10h30c5.523 0 10-4.477 10-10V10c0-5.523-4.477-10-10-10H90c-5.523 0-10 4.477-10 10M160 80v30c0 5.523 4.477 10 10 10h30c5.523 0 10-4.477 10-10V80c0-5.523-4.477-10-10-10h-30c-5.523 0-10 4.477-10 10M160 10v30c0 5.523 4.477 10 10 10h30c5.523 0 10-4.477 10-10V10c0-5.523-4.477-10-10-10h-30c-5.523 0-10 4.477-10 10"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "draggable-dots-horizontal_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 120V0h210v120z"
  })))));
};
export default SvgDraggableDotsHorizontal;